











import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import PlushieStore from "@/modules/plushie/store";
import Plushie from "@/modules/plushie/plushie.model";
import dataStore from "@/store";

@Component({
  metaInfo() {
    const component = this as RejectSuccessPage;

    let titlePrefix = "";
    if (component.plushie != null) {
      titlePrefix = component.plushie.storeItemId + " ";
    }

    return {
      title: titlePrefix + "Design Clarification Received",
    };
  },
  components: {},
})
export default class RejectSuccessPage extends Vue {
  @Prop({ required: true })
  public readonly plushieId!: string;

  private fPlushieDataStore: PlushieStore;

  get plushie(): Plushie | undefined {
    return this.fPlushieDataStore.getPlushieById(this.plushieId);
  }

  constructor() {
    super();
    this.fPlushieDataStore = getModule(PlushieStore, dataStore);
  }

  private async getPlushieData(plushieId: string): Promise<void> {
    await this.fPlushieDataStore.loadPlushieById({ id: plushieId });
  }

  @Watch("plushieId", { immediate: true })
  private async onPlushieIdChange(): Promise<void> {
    if (!this.plushieId) {
      return;
    }

    await this.getPlushieData(this.plushieId);
  }
}
